import React, { useMemo, useState } from "react";
import SurveilPatient from "./SurveilPatient";
import Monitor from "../Monitor";
import className from "../../shared/className";

export default function FullMonitor({ parent, patient, sweepModeEnabled }) {
  const [alarm, setAlarm] = useState();
  const focusMode = parent.store.focusMode;

  const canvasWorker = useMemo(() => {
    return parent.getCanvasWorkerInstance({
      instanceId: `${patient.asmpid}-full${focusMode ? "-focused" : ""}`,
    });
  }, [patient.asmpid]);

  const splitScreen = Boolean(parent.store.splitScreen);
  if (!focusMode) {
    parent.measurementsTargets[patient.asmpid] =
      parent.measurementsTargets[patient.asmpid] || new MeasurementsTarget();
    React.useEffect(() => {
      return () => {
        delete parent.measurementsTargets[patient.asmpid];
      };
    }, [patient.asmpid]);
  }

  const isEmptyBed =
    (patient.status === "inactive" && patient.mrnState === "MrnFixed") ||
    patient.isEmptyBed;

  return patient ? (
    <div
      {...className({
        "full-monitor": true,
        "split-screen-item": parent.store.splitScreen,
        focused: focusMode,
      })}
    >
      <SurveilPatient
        header
        close={() => parent.selectPatient(null)}
        patient={patient}
        moduleSpecifics={parent.store.moduleSpecifics(patient)}
        alarm={alarm}
      />
      {!isEmptyBed ? (
        <Monitor
          {...parent.props}
          asmpid={patient.asmpid}
          suppressRouting={true}
          fitWaveforms={true}
          disableTrends={true}
          zoom={parent.store.monitorZoom}
          isEmbedded={splitScreen}
          canvasWorker={canvasWorker}
          measurementsSource={
            splitScreen ? parent.measurementsTargets[patient.asmpid] : null
          }
          setAlarm={setAlarm}
          liveOnly={!focusMode && parent.store.liveOnly}
          patient={patient}
          sweepMode={sweepModeEnabled}
        />
      ) : (
        <div className="full-monitor-placeholder">
          <span>NO PATIENT CONNECTED</span>
        </div>
      )}
    </div>
  ) : null;
}

export class MeasurementsTarget extends EventTarget {
  constructor() {
    super();
  }
  pause() {
    this.paused = true;
  }
  resume() {
    this.paused = false;
  }
}
